<template>
  <section class="endorsement-info">
    <div
      v-if="showEffectDate"
      class="table strip eff-box">
      <div class="tr">
        <span>{{isCancel?'Cancellation Effective Date':'Endorsement Effective Date'}}</span>
        <span>{{ isCancel ? formData.pcy_expry_dt : formData.pcy_cmnt_dt }}</span>
      </div>
    </div>
    <h2>Premium</h2>

    <premium-form-endorsement
      ref="premium-form-endorsement"
      :classId="classId"
      :productId="productId"
      :form="form"
      :oldForm="oldForm"
      :prePremium="prePremium"
      :newPremium="newPremium"
      :diffPayable="diffPayable"
      :premiumData="premiumData"
      :isCancel="isCancel"
      :info="info"
      :orderId="orderId"
      :isRefer="isRefer"
      :mockRefer="mockRefer"
      :has-remark="isNext"
      :formDataLock="formDataLock"
      @input-handling="handlerPremiumInputHanding"
      @get-quote="handlerPremiumGetQuoteMain"
      @get-form="handlerGetPremiumForm"
      @updateCancelPremium="handleCancelUpdatePremium"
      @update-form="handlerUpdatePremiumForm" />

    <div
      v-if="false"
      class="premium-container">
      <div class="box">
        <h4>{{ isCancel ? '' : 'Previous' }} Remaining Premium</h4>
        <div
          v-if="isCancel"
          class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Percentage</span>
            <span>Amount</span>
          </div>
          <div
            v-for="(item, index) in remainPremium"
            :key="'re-' + index"
            class="tr">
            <span>{{ item.item }}</span>
            <span>{{ item.pct }}</span>
            <span>{{ item.amount | formatMoney(2, true) }}</span>
          </div>
          <div
            v-if="nowExtraContent.length>0"
            class="extra-content-cancel">
            <div
              v-for="(extra, excessIndex) in nowExtraContent"
              :key="'ext' + excessIndex"
              class="tr-extra">
              <div class="tr ">
                <span class="extra-title">{{extra.name}}</span>
              </div>
              <div
                v-for="(subItem, subIndex) in extra.content.coverage"
                :key="'coverage-extra' + excessIndex + subIndex"
                class="tr">
                <span>{{ subItem.name }}</span>
                <span class="text-right">{{ subItem.money }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="!info"
          class="table"
        >
          <div >
            <div class="tr th">
              <span>Item</span>
              <span>Percentage</span>
              <span>Amount</span>
            </div>
            <div class="tr">
              <span>Basic Premium</span>
              <span>-</span>
              <span>{{ productId == 11? oldForm.base_prm: oldForm.basic_prm | formatMoney(2, true) }}</span>
            </div>
            <template v-if="productId == 11">
              <div class="tr">
                <span>Client Discount</span>
                <span>{{ oldForm.srd_pct }}%</span>
                <span>{{ oldForm.srd_amt | formatMoney(2, true) }}</span>
              </div>
              <div class="tr">
                <span>Loading</span>
                <span>{{ oldForm.loading_pct }}%</span>
                <span>{{ oldForm.loading_amt | formatMoney(2, true) }}</span>
              </div>
              <div class="tr">
                <span>NCD</span>
                <span>{{ oldForm.ncd_pct }}%</span>
                <span>{{ oldForm.ncd_vl | formatMoney(2, true) }}</span>
              </div>
            </template>

            <div class="tr">
              <span>MGM Discount</span>
              <span>-</span>
              <span>{{ oldForm.code_disc_prm | formatMoney(2, true) }}</span>
            </div>
            <div
              v-if="productId == 11"
              class="tr">
              <span>MIB</span>
              <span>{{ oldForm.mib_pct }}%</span>
              <span>{{ oldForm.mib_vl | formatMoney(2, true) }}</span>
            </div>
            <div class="tr">
              <span>IA Levy</span>
              <span>{{ oldForm.ia_levy_pct }}%</span>
              <span>{{ oldForm.ia_levy_vl | formatMoney(2, true) }}</span>
            </div>
            <div class="tr">
              <span>Manual Discount</span>
              <span>{{ oldForm.spec_disc_pct }}%</span>
              <span>{{ oldForm.spec_disc_prm | formatMoney(2, true) }}</span>
            </div>

          </div>

          <div class="tr">
            <span>Days Remaining</span>
            <span>{{ prePremium.remaining_day }}</span>
            <span>{{ prePremium.remaining_day }}</span>
          </div>
          <div class="tr">
            <span>Remaining Premium</span>
            <span>-</span>
            <span>{{ prePremium.remaining_premium | formatMoney(2, true) }}</span>
          </div>
        </div>


        <div
          v-else
          class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Percentage</span>
            <span>Amount</span>
          </div>
          <div class="tr">
            <span>Basic Premium</span>
            <span>-</span>
            <span>{{ productId == 11? oldForm.base_prm: oldForm.basic_prm | formatMoney(2, true) }}</span>
          </div>
          <template v-if="productId == 11">
            <div class="tr">
              <span>Client Discount</span>
              <span>{{ oldForm.srd_pct }}%</span>
              <span>{{ oldForm.srd_amt | formatMoney(2, true) }}</span>
            </div>
            <div class="tr">
              <span>Loading</span>
              <span>{{ oldForm.loading_pct }}%</span>
              <span>{{ oldForm.loading_amt | formatMoney(2, true) }}</span>
            </div>
            <div class="tr">
              <span>NCD</span>
              <span>{{ oldForm.ncd_pct }}%</span>
              <span>{{ oldForm.ncd_vl | formatMoney(2, true) }}</span>
            </div>
          </template>
          <div class="tr">
            <span>MGM Discount</span>
            <span>-</span>
            <span>{{ oldForm.code_disc_prm | formatMoney(2, true) }}</span>
          </div>
          <div
            v-if="productId == 11"
            class="tr">
            <span>MIB</span>
            <span>{{ oldForm.mib_pct }}%</span>
            <span>{{ oldForm.mib_vl | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>IA Levy</span>
            <span>{{ oldForm.ia_levy_pct }}%</span>
            <span>{{ oldForm.ia_levy_vl | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Manual Discount</span>
            <span>{{ oldForm.spec_disc_pct }}%</span>
            <span>{{ oldForm.spec_disc_prm | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Days Remaining</span>
            <span>{{ oldForm.remaining_day }}</span>
            <span>{{ oldForm.remaining_day }}</span>
          </div>
          <div class="tr">
            <span>Remaining Premium</span>
            <span>-</span>
            <span>{{ oldForm.remaining_premium | formatMoney(2, true) }}</span>
          </div>
        </div>
      </div>
      <div
        v-if="!isCancel"
        class="box">
        <h4>New Remaining Premium</h4>
        <div
          v-if="info"
          class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Percentage</span>
            <span>Amount</span>
          </div>
          <div class="tr">
            <span>Basic Premium</span>
            <span>-</span>
            <span>{{ productId == 11? form.base_prm: form.basic_prm | formatMoney(2, true) }}</span>
          </div>
          <template v-if="productId == 11">
            <div class="tr">
              <span>Client Discount</span>
              <span>{{ form.srd_pct }}%</span>
              <span>{{ form.srd_amt | formatMoney(2, true) }}</span>
            </div>
            <div class="tr">
              <span>Loading</span>
              <span>{{ form.loading_pct }}%</span>
              <span>{{ form.loading_amt | formatMoney(2, true) }}</span>
            </div>
            <div class="tr">
              <span>NCD</span>
              <span>{{ form.ncd_pct }}%</span>
              <span>{{ form.ncd_vl | formatMoney(2, true) }}</span>
            </div>
          </template>


          <div class="tr">
            <span>MGM Discount</span>
            <span>-</span>
            <span>{{ form.code_disc_prm | formatMoney(2, true) }}</span>
          </div>
          <div
            v-if="productId == 11"
            class="tr">
            <span>MIB</span>
            <span>{{ form.mib_pct }}%</span>
            <span>{{ form.mib_vl | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>IA Levy</span>
            <span>{{ form.ia_levy_pct }}%</span>
            <span>{{ form.ia_levy_vl | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Manual Discount</span>
            <span>{{ form.spec_disc_pct }}%</span>
            <span>{{ form.spec_disc_prm | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Days Remaining</span>
            <span>{{ form.remaining_day }}</span>
            <span>{{ form.remaining_day }}</span>
          </div>
          <div class="tr">
            <span>Remaining Premium</span>
            <span>-</span>
            <span>{{ form.remaining_premium | formatMoney(2, true) }}</span>
          </div>
        </div>
        <section v-else>
          <section v-show="!mockRefer">
            <div
              v-if="isRefer"
              class="table">
              <div class="tr th">
                <span>Item</span>
                <span>Amount</span>
              </div>

              <el-form
                ref="premium-form"
                :model="premiumForm"
                :rules="rules">

                <template v-if="productId == 15">
                  <div class="tr">
                    <span>
                      Section I - Material Damage Premium
                      <br />
                      <el-form-item prop="mat_dam_prm">
                        <v-input
                          v-model="premiumForm.mat_dam_prm"
                          prepend="$"
                          @blur="handlerGetQuoteMain"
                          @keyEnter="handlerGetQuoteMain" />
                      </el-form-item>
                    </span>
                  </div>
                  <div class="tr">
                    <span>
                      Section II - 3rd Party Liability Premium
                      <br />
                      <el-form-item prop="tppd_limit_prm">
                        <v-input
                          v-model="premiumForm.tppd_limit_prm"
                          prepend="$"
                          @blur="handlerGetQuoteMain"
                          @keyEnter="handlerGetQuoteMain" />
                      </el-form-item>
                    </span>
                  </div>
                </template>
                <div
                  v-else
                  class="tr">
                  <span>
                    Basic Premium
                    <br/>
                    <el-form-item
                      v-if="productId == 11"
                      prop="base_prm">
                      <v-input
                        v-model="premiumForm.base_prm"
                        prepend="$"
                        @blur="handlerGetQuoteMain"
                        @keyEnter="handlerGetQuoteMain"/>
                    </el-form-item>
                    <el-form-item
                      v-else
                      prop="basic_prm">
                      <v-input
                        v-model="premiumForm.basic_prm"
                        prepend="$"
                        @blur="handlerGetQuoteMain"
                        @keyEnter="handlerGetQuoteMain"/>
                    </el-form-item>
                  </span>
                  <span>{{ productId == 11? premiumForm.base_prm: premiumForm.basic_prm | formatMoney(2, true) }}</span>
                <!-- <span>{{ productId == 11? newPremium.base_prm: newPremium.basic_prm | formatMoney(2, true) }}</span> -->
                </div>
                <template v-if="productId == 11">


                  <div class="tr">
                    <span>
                      Client Discount
                      <br/>
                      <el-form-item prop="srd_pct">
                        <v-input
                          v-model="premiumForm.srd_pct"
                          append="%"
                          @blur="handlerGetQuoteMain"
                          @keyEnter="handlerGetQuoteMain"/>
                      </el-form-item>
                    </span>
                    <span>{{ newPremium.srd_amt | formatMoney(2, true) }}</span>
                  </div>
                  <div class="tr">
                    <span>Loading
                      <br/>
                      <el-form-item prop="loading_pct">
                        <v-input
                          v-model="premiumForm.loading_pct"
                          append="%"
                          @blur="handlerGetQuoteMain"
                          @keyEnter="handlerGetQuoteMain"/>
                      </el-form-item>
                    </span>
                    <span>{{ newPremium.loading_amt | formatMoney(2, true) }}</span>
                  </div>
                  <div class="tr">
                    <span>NCD
                      <br/>
                      <el-form-item prop="cfd_pct">
                        <v-input
                          v-model="premiumForm.cfd_pct"
                          append="%"
                          @blur="handlerGetQuoteMain"
                          @keyEnter="handlerGetQuoteMain"/>
                      </el-form-item>
                    </span>
                    <span>{{ newPremium.cfd_amt | formatMoney(2, true) }}</span>
                  </div>
                </template>
                <div
                  v-if="showECLevy"
                  class="tr">
                  <span>Employee Compensation Premium
                    <br/>
                    <el-form-item prop="ec_levy_prm">
                      <v-input
                        v-model="premiumForm.ec_levy_prm"
                        @blur="handlerGetQuoteMain"
                        @keyEnter="handlerGetQuoteMain"/>
                    </el-form-item>
                  </span>
                  <span>{{ premiumForm.ec_levy_prm | formatMoney(2, true) }}</span>
                </div>

                <div class="tr">
                  <span>MGM Discount
                    <br/>
                    <el-form-item prop="code_disc_pct">
                      <v-input
                        v-model="premiumForm.code_disc_pct"
                        append="%"
                        @blur="handlerGetQuoteMain"
                        @keyEnter="handlerGetQuoteMain"/>
                    </el-form-item>
                  </span>
                  <span>{{ newPremium.code_disc_prm | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="productId == 11"
                  class="tr">
                  <span>MIB</span>
                  <span>{{ newPremium.mib_pct }}%</span>
                  <span>{{ newPremium.mib_vl | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="showECLevy"
                  class="tr">
                  <span>EC Levy</span>
                  <span>{{ newPremium.ec_levy_pct }}%</span>
                  <span>{{ newPremium.ec_levy_vl | formatMoney(2, true) }}</span>
                </div>
                <div class="tr">
                  <span>IA Levy</span>
                  <span>{{ newPremium.ia_levy_pct }}%</span>
                  <span>{{ newPremium.ia_levy_vl | formatMoney(2, true) }}</span>
                </div>
                <div class="tr">
                  <span>Manual Discount
                    <br/>
                    <el-form-item prop="spec_disc_prm">
                      <v-input
                        v-model="premiumForm.spec_disc_prm"
                        append="HK$"
                        @blur="handlerGetQuoteMain"
                        @keyEnter="handlerGetQuoteMain"/>
                    </el-form-item>
                  </span>
                  <span>{{ premiumForm.spec_disc_prm | formatMoney(2, true) }}</span>
                </div>
                <div class="tr">
                  <span>Days Remaining</span>
                  <span>{{ newPremium.remaining_day }}</span>
                  <span>{{ newPremium.remaining_day }}</span>
                </div>
                <div class="tr">
                  <span>Remaining Premium</span>
                  <span>-</span>
                  <span>{{ newPremium.remaining_premium | formatMoney(2, true) }}</span>
                </div>

              </el-form>


            </div>
            <div
              v-else
              class="table">
              <div class="tr th">
                <span>Item</span>
                <span>Percentage</span>
                <span>Amount</span>
              </div>
              <div class="tr">
                <span>Basic Premium</span>
                <span>-</span>
                <span>{{ productId == 11? newPremium.base_prm: newPremium.basic_prm | formatMoney(2, true) }}</span>
              </div>
              <template v-if="productId == 11">
                <div class="tr">
                  <span>Client Discount</span>
                  <span>{{ newPremium.srd_pct }}%</span>
                  <span>{{ newPremium.srd_amt | formatMoney(2, true) }}</span>
                </div>
                <div class="tr">
                  <span>Loading</span>
                  <span>{{ newPremium.loading_pct }}%</span>
                  <span>{{ newPremium.loading_amt | formatMoney(2, true) }}</span>
                </div>
                <div class="tr">
                  <span>NCD</span>
                  <span>{{ newPremium.cfd_pct }}%</span>
                  <span>{{ newPremium.cfd_amt | formatMoney(2, true) }}</span>
                </div>
              </template>

              <div class="tr">
                <span>MGM Discount</span>
                <span>-</span>
                <span>{{ newPremium.code_disc_prm | formatMoney(2, true) }}</span>
              </div>
              <div
                v-if="productId == 11"
                class="tr">
                <span>MIB</span>
                <span>{{ newPremium.mib_pct }}%</span>
                <span>{{ newPremium.mib_vl | formatMoney(2, true) }}</span>
              </div>
              <div class="tr">
                <span>IA Levy</span>
                <span>{{ newPremium.ia_levy_pct }}%</span>
                <span>{{ newPremium.ia_levy_vl | formatMoney(2, true) }}</span>
              </div>
              <div class="tr">
                <span>Manual Discount</span>
                <span>{{ newPremium.spec_disc_pct }}%</span>
                <span>{{ newPremium.spec_disc_prm | formatMoney(2, true) }}</span>
              </div>
              <div class="tr">
                <span>Days Remaining</span>
                <span>{{ newPremium.remaining_day }}</span>
                <span>{{ newPremium.remaining_day }}</span>
              </div>
              <div class="tr">
                <span>Remaining Premium</span>
                <span>-</span>
                <span>{{ newPremium.remaining_premium | formatMoney(2, true) }}</span>
              </div>
            </div>
          </section>
          <p
            v-show="mockRefer"
            class="refer-text">These modifications would need to be referred to insurer.</p>
        </section>
      </div>
      <div class="box">
        <section v-show="!mockRefer">
          <h4>Difference Payable</h4>
          <div
            v-if="info"
            class="table">
            <div class="tr th">
              <span>Item</span>
              <span>Amount</span>
            </div>
            <div class="tr">
              <span>Previous Remaining Premium</span>
              <span>{{ oldForm.remaining_premium | formatMoney(2, true) }}</span>
            </div>
            <div class="tr">
              <span>New Remaining Premium</span>
              <span>{{ form.remaining_premium | formatMoney(2, true) }}</span>
            </div>
            <div
              class="tr">
              <span>Admin Charge
              </span>
              <span>
                {{ form.handling_fee | formatMoney(2, true) }}
              </span>
            </div>
            <div class="tr">
              <span>Payable</span>
              <span>{{ form.amount | formatMoney(2, true) }}</span>
            </div>
          </div>
          <div
            v-else
            class="table">
            <div class="tr th">
              <span>Item</span>
              <span>Amount</span>
            </div>
            <div class="tr">
              <span>Previous Remaining Premium</span>
              <span>{{ prePremium.remaining_premium | formatMoney(2, true) }}</span>
            </div>
            <div
              v-if="!isCancel"
              class="tr">
              <span>New Remaining Premium</span>
              <span>{{ newPremium.remaining_premium | formatMoney(2, true) }}</span>
            </div>
            <div
              class="tr">
              <span>Admin Charge
                <br/>
                <v-input
                  v-model="premiumForm.handling_fee"
                  prepend="$"
                  @input="inputHandlingFee"/>
              </span>
              <span>
                {{ premiumForm.handling_fee | formatMoney(2, true) }}
              </span>
            </div>
            <div class="tr">
              <span>{{ isCancel ? 'Refund' : 'Payable' }}</span>
              <span>{{ diffPayable.payable | formatMoney(2, true) }}</span>
            </div>
          </div>
        </section>
      </div>
    </div>






    <div class="form-half mg-b-15">
      <h3>Detail of Change</h3>
      <v-input
        v-model="otherForm.change_remark"
        type="textarea"
        :rows="4" />

      <h3 class="mg-t-10">Remarks</h3>
      <v-input
        v-model="otherForm.endorse_remark"
        type="textarea"
        :rows="4" />
    </div>

    <section class="box-container">
      <h2>Excess</h2>
      <!-- 這裏也要區分產品 -->
      <product-excess-form
        v-if="isRefer&&!hasExcess"
        ref="excess-form"
        :formDataLock="formDataLock"
        :form="formData"/>
      <!-- <excess-form
        v-if="isRefer"
        ref="excess-form"
        :formDataLock="formDataLock"
        :form="formData"/> -->
      <excess-info
        v-else
        ref="excess-info"
        :formData="formData"/>




      <!--      车保-->
      <div v-if="productId == 11">
        <h2>Car Detail</h2>
        <insured-vehicle-info-compare
          :form="formData"
          :oldForm="oldForm"/>

        <h2>Policyholder</h2>
        <policy-holder-info
          :form="formData"
          :oldForm="oldForm"
          :isEndorsement="true"/>

        <h2>Driver(s)</h2>
        <drivers-info
          :form="formData"
          :preFormData="oldForm"
          :isEndorsement="true"/>
      </div>
      <!--      家佣/工程/家居-->
      <div v-else>
        <h2>Client Info</h2>
        <housemaid-quote-info
          v-if='productId == 12'
          :formData="formData"
          :oldForm="oldForm"
          :isEndorsement="true"
        />
        <working-quote-info
          v-else-if="productId == 13"
          :formData="form"
          :oldForm="oldForm"
          :isEndorsement="true"
        />
        <decoration-quote-info
          v-else-if="productId == 15"
          :formData="form"
          :oldForm="oldForm"
          :isEndorsement="true"
        />
        <travel-quote-info
          v-else-if="productId == 14"
          :formData="form"
          :oldForm="oldForm"
          :isEndorsement="true"
        />
        <student-quote-info
          v-else-if="productId == 16"
          Account
          :formData="form"
          :oldForm="oldForm"
          :isEndorsement="true"
        />
        <homefire-quote-info
          v-else-if="productId == 17"
          Account
          :formData="form"
          :oldForm="oldForm"
          :isEndorsement="true"
        />
        <personal-quote-info
          v-else-if="productId == 18"
          Account
          :formData="form"
          :oldForm="oldForm"
          :isEndorsement="true"
        />
        <fire-quote-info
          v-else-if="productId == 20"
          Account
          :formData="form"
          :oldForm="oldForm"
          :isEndorsement="true"
        />
        <pet-quote-info
          v-else-if="productId == 22"
          Account
          :formData="form"
          :oldForm="oldForm"
          :isEndorsement="true"
          :isCancel="isCancel"
        />
      </div>
    </section>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import DriversInfo from '@/views/tickets/components/info/drivers-info'
import PolicyHolderInfo from '@/views/tickets/components/info/policy-holder-info'
import InsuredVehicleInfoCompare from '@/views/components/insured-vehicle-info-compare'
// import ExcessForm from './form/excess-form'
import ExcessInfo from './info/excess-info'
import OMath from '@/utils/math'
import DecorationQuoteInfo from '@/views/components/modules/decoration/decoration-quote-info'
import HomefireQuoteInfo from '@/views/components/modules/homefire/homefire-quote-info'
import fireQuoteInfo from '@/views/components/modules/homefire/fire-quote-info'
import HousemaidQuoteInfo from '@/views/components/modules/housemaid/housemaid-quote-info'
import TravelQuoteInfo from '@/views/components/modules/travel/travel-quote-info'
import StudentQuoteInfo from '@/views/components/modules/student/student-quote-info'
import WorkingQuoteInfo from '@/views/components/modules/working/working-quote-info'
import PersonalQuoteInfo from '@/views/components/modules/personal/personal-quote-info'
import petQuoteInfo from '@/views/components/modules/pet/pet-quote-info'
import ProductExcessForm from '@/views/tickets/components/form/product-excess-form'

import PremiumFormEndorsement from '@/views/components/premium-form-endorsement'

export default {
  name: 'EndorsementInfo',
  components: {
    DriversInfo,
    PolicyHolderInfo,
    InsuredVehicleInfoCompare,
    // ExcessForm,
    ExcessInfo,
    HousemaidQuoteInfo,
    DecorationQuoteInfo,
    HomefireQuoteInfo,
    TravelQuoteInfo,
    WorkingQuoteInfo,
    StudentQuoteInfo,
    ProductExcessForm,
    PremiumFormEndorsement,
    fireQuoteInfo,
    PersonalQuoteInfo,
    petQuoteInfo
  },
  mixins: [MixinOptions, MixinFormat, MixinRules],
  props: {
    isRefer: {
      type: Boolean,
      default: false
    },
    isNext: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    info: {
      type: Boolean,
      default: false
    },
    mock: {
      type: Boolean,
      default: false
    },
    premiumData: {
      type: Object,
      default: () => ({})
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    isBeginEndorsement: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      // excessCheckbox: [
      //   {
      //     status: false,
      //     vlKey: 'general_ex_vl',
      //     typKey: 'general_ex_typ'
      //   },
      //   {
      //     status: false,
      //     vlKey: 'china_general_ex_vl',
      //     typKey: 'china_general_ex_typ'
      //   },
      //   {
      //     status: false,
      //     vlKey: 'theft_loss_ex_vl',
      //     typKey: 'theft_loss_ex_typ'
      //   },
      //   {
      //     status: false,
      //     vlKey: 'china_theft_loss_ex',
      //     typKey: 'china_theft_loss_typ'
      //   },
      // ],
      formData: {
        // excessCheckbox: [
        //   {},
        //   {},
        //   {},
        //   {}
        // ]
      },
      remainPremium: [],
      prePremium: {},
      newPremium: {
        base_prm: '',
        basic_prm: '',
        srd_amt: '',
        loading_amt: '',
        ncd_vl: '',
        code_disc_prm: '',
        mib_vl: '',
        mib_pct: '',
        ia_levy_pct: '',
        ia_levy_vl: '',
        spec_disc_prm: '',
        remaining_day: '',
        remaining_premium: '',
        // 裝修工程
        ec_levy_pct: '',
        ec_levy_vl: ''
      },
      diffPayable: {
        payable: ''
      },
      premiumForm: {
        handling_fee: 0,
        spec_disc_pct: '',
        code_disc_pct: '',
        cfd_pct: '',
        loading_pct: '',
        srd_pct: '',
        base_prm: '',
        basic_prm: '',
        spec_disc_prm: '',
        // 裝修工程
        ec_levy_prm: '',
        mat_dam_prm: '',
        tppd_limit_prm: ''
        // excess
        // tppd_ex: '',
        // tppd_young_driver_ex: '',
        // tppd_inexp_driver_ex: '',
        // tppd_unnamed_driver_ex: '',
        // remark: ''
      },
      // 用於判斷手填 premium 數據是否有變化（避免失去焦點時多次觸發）
      oldPremiumForm: {
        handling_fee: '',
        spec_disc_pct: '',
        code_disc_pct: '',
        cfd_pct: '',
        loading_pct: '',
        srd_pct: '',
        base_prm: '',
        basic_prm: '',
        spec_disc_prm: '',
        // 裝修工程
        ec_levy_prm: '',
        mat_dam_prm: '',
        tppd_limit_prm: ''
      },
      otherForm: {
        change_remark: '',
        endorse_remark: ''
      },
      premiumLock: false,
      tempPremium: {},
      formDataLock: 0,
      // 新增 premium 組件裡的
      premiumFormData: {}, //
      premiumParams: {},
      updatePremiumForm: {}

    }
  },
  computed: {
    oldExtraContent(){
      let {extra_benefits_content={}} = this.oldForm||{}
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr
    },
    nowExtraContent(){
      let {extra_benefits_content={}} = this.form||{}
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr
    },
    classId() {
      return this.form.class_id || 0
    },
    showEffectDate() {
      if (this.isRefer && !this.mock) {
        return false
      }
      return true
    },
    mockRefer() {
      if (this.isRefer && this.mock) {
        return true
      }
      return false
    },
    productId() {
      return this.form.product_id || 11
    },
    showECLevy() {
      const { ec_levy_pct } = this.formData
      return this.productId == 15 && ec_levy_pct > 0
    },
    hasExcess(){
      return [13,14,16,18].includes(this.productId)
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        const params = Object.assign(this.formData, val)
        this.formDataLock += 1
        this.formData = JSON.parse(JSON.stringify(params))
        // refer 才會用到
        // if (this.isRefer) {
        Object.keys(this.premiumForm).some(key => {
          // if(key == 'handling_fee') {
          //   this.premiumForm[key] = 0
          // }
          // else {
          if (key in this.formData) {
            this.premiumForm[key] = this.formData[key]
          }
          if (key == 'cfd_pct') {
            this.premiumForm['cfd_pct'] = val['ncd_pct']
          }
          if (key == 'cfd_amt') {
            this.premiumForm['cfd_amt'] = val['ncd_vl']
          }
          // }
        })
        // }
        // this.handlerGetQuoteMain()
        if(!this.isBeginEndorsement) {
          Object.keys(this.otherForm).some(key => {
            if(key in this.formData) {
              this.otherForm[key] = this.formData[key]
            }
          })
        }



      }
    },
    premiumData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val.diff_payable && JSON.stringify(val.diff_payable) != '{}') {
          let data = JSON.parse(JSON.stringify(val))
          const {diff_payable = {}, new_premium = {}, old_premium = {}, remain_premium = []} = data
          this.prePremium = old_premium
          this.diffPayable = diff_payable
          this.remainPremium = remain_premium

          if(this.isCancel){
            const { handling_fee = 0 } = diff_payable
            this.premiumForm.handling_fee = handling_fee
          }else{
            const { handling_fee = 0 } = new_premium
            this.premiumForm.handling_fee = handling_fee
          }

          if (!this.isCancel) {
            let temp = this.handler().initNewPremium(this.newPremium)
            this.newPremium = Object.assign(temp, new_premium)
          }
          // 初始化数据，可能会因为手续费问题产生差异，所以这里重新计算一下
          this.inputHandlingFee(this.premiumForm.handling_fee)
        }
      }
    },
    info:{
      immediate: true,
      handler(val){
        if(val){
          let temp = this.handler().initNewPremium(this.newPremium)
          this.newPremium = Object.assign(temp, this.form)
          let extraBenefitPremium = {
            new_premium: this.form.extra_benefits_content,
            old_premium: this.oldForm.extra_benefits_content
          }
          this.premiumData.extra_benefits_premium = extraBenefitPremium
        }
      }
    },
    'diffPayable.payable': {
      immediate: true,
      deep: true,
      handler(val) {
        this.$emit('get-payable', OMath.round(val))
      }
    },
    // 'premiumForm.handling_fee': {
    //   immediate: true,
    //   deep: true,
    //   handler(val) {
    //     this.$emit('get-handlingfee', OMath.round(val))
    //   }
    // },
    // premium 組件新增
    'updatePremiumForm.handling_fee': {
      immediate: true,
      deep: true,
      handler(val) {
        this.$emit('get-handlingfee', OMath.round(val))
      }
    },
  },
  methods: {
    submitForm(type) {
      // 反饋 premium 數據
      let params = {
        loading_pct: '',
        base_prm: '',
        cfd_pct: this.formData.ncd_pct,
        srd_pct: '',
        code_disc_pct: '',
        spec_disc_pct: '',
        spec_disc_prm: '',
        handling_fee: this.premiumForm.handling_fee,
        basic_prm:'',
        // tppd_ex: '',
        // tppd_young_driver_ex: '',
        // tppd_inexp_driver_ex: '',
        // tppd_unnamed_driver_ex: '',
        // remark: ''
      }
      Object.keys(params).some(key => {
        if (key in this.formData) {
          if (params[key] === '') {
            params[key] = this.formData[key]
          }
        }
      })

      // params = {
      //   ...params,
      //   ...this.otherForm
      // }

      this.premiumParams = params //  臨時存儲
      this.$refs['premium-form-endorsement'].submitForm(type)


      // if (this.isRefer) {


      // this.$refs['premium-form'].validate((valid, rules) => {
      //   if(valid) {
      //     // base_prm
      //     params = Object.assign(params, this.premiumForm)
      //     // this.tempPremium = params
      //     // refer 的話還需要獲取 excess 數據
      //     const excessParams = this.$refs['excess-form'].submitForm()
      //     params = Object.assign(params, excessParams)
      //     // 要多加個表單校驗，和下面區分開寫了
      //     params.plan_id = this.formData.quote_coverage_list.plan_info.plan_id || ''
      //     this.$emit('getFormData', params, type, this.otherForm)
      //   }
      // })

      // }
      // 非 refer
      // else {
      //   const excessInfo = this.$refs['excess-info'].submitInfo()
      //   params = Object.assign(params, excessInfo)

      //   params.plan_id = this.formData.quote_coverage_list.plan_info.plan_id || ''
      //   this.$emit('getFormData', params, type, this.otherForm)
      // }

    },
    getExcessFormData(data) {
      const params = Object.assign(this.tempPremium, data)
      this.$emit('getFormData', params)
    },
    handlerGetQuoteMain() {
      const checked = this.handler().checkParams()
      if (checked) {
        this.$emit('get-quote', this.premiumForm)
      }
    },
    handlerPremiumGetQuoteMain(form) {
      this.$emit('get-quote', form)
    },
    handlerGetPremiumForm(form, type) {
      this.premiumFormData = form
      let params = Object.assign(this.premiumParams, form)
      if(this.isRefer) {
        if(!this.hasExcess){
          const excessParams = this.$refs['excess-form'].submitForm()
          params = Object.assign(params, excessParams)
        }
        params.plan_id = this.formData.quote_coverage_list.plan_info.plan_id || ''
        this.$emit('getFormData', params, type, this.otherForm)
      }
      else {
        const excessInfo = this.$refs['excess-info'].submitInfo()
        params = Object.assign(params, excessInfo)

        params.plan_id = this.formData.quote_coverage_list.plan_info.plan_id || ''
        this.$emit('getFormData', params, type, this.otherForm)
      }


    },
    handlerUpdatePremiumForm(form) {
      this.updatePremiumForm = form
    },
    handleCancelUpdatePremium(val){
      this.$emit('updateCancelPremium', val)
    },
    handlerPremiumInputHanding(value) {
      this.inputHandlingFee(value)
    },
    inputHandlingFee(val) {
      const value = Number(OMath.round(val))
      const prePayable = Number(OMath.round(this.prePremium.remaining_premium))
      const diffPayable = Number(Math.abs(this.diffPayable.payable))
      let result
      if (this.isCancel) {
        // 因爲顯示的是正數，所以
        result = OMath.round(diffPayable)
        // result = OMath.round(diffPayable - value)
        this.$set(this.diffPayable, 'payable', result)
      } else {
        const newPayable = Number(OMath.round(this.newPremium.remaining_premium))
        result = OMath.round(newPayable + value - prePayable)
        // this.diffPayable.payable = result
        result = this.diffPayable.payable
        this.$set(this.diffPayable, 'payable', result)
      }

    },
    handler() {
      return {
        checkParams: () => {
          let flag = false // 標記是否有空
          let different = false

          // let premiumForm = JSON.parse(JSON.stringify(this.premiumForm))
          // if(this.productId != 11) {
          //   delete premiumForm.base_prm
          //   delete premiumForm.srd_pct
          //   delete premiumForm.loading_pct
          //   delete premiumForm.cfd_pct
          // }
          // else {
          //   delete premiumForm.basic_prm
          // }

          const {
            base_prm,
            basic_prm,
            srd_pct,
            loading_pct,
            cfd_pct,
            code_disc_pct,
            spec_disc_prm,
            // handling_fee
            ec_levy_prm,
            mat_dam_prm,
            tppd_limit_prm
          } = this.premiumForm

          let premiumForm = {
            code_disc_pct,
            spec_disc_prm,
            // handling_fee
          }
          if(this.productId == 11) {
            premiumForm = {
              ...premiumForm,
              base_prm,
              srd_pct,
              loading_pct,
              cfd_pct
            }
          }
          else {
            premiumForm = {
              ...premiumForm,
              basic_prm
            }
          }

          if(this.productId == 15) {
            premiumForm = {
              ...premiumForm,
              ec_levy_prm,
              mat_dam_prm,
              tppd_limit_prm
            }
          }


          Object.keys(premiumForm).some(key => {
            const value = this.premiumForm[key]
            if (String(value).trim() === '') {
              flag = true
              return true
            }
            const oldValue = this.oldPremiumForm[key]
            if (value !== oldValue) {
              different = true
            }
          })
          if (flag || !different) {
            return false
          }
          this.oldPremiumForm = JSON.parse(JSON.stringify(this.premiumForm))

          return true
        },
        initNewPremium: (data) => {
          let result = {}
          Object.keys(data).some(key => {
            result[key] = this.formData[key]
          })
          return result
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.endorsement-info {
  // padding-top: 15px;
  .premium-container {
    display: flex;

    & > .box {
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }
    }

    .box {
      flex: 1;
    }
  }

  .eff-box {
    width: 350px;
  }

  .box {
    .flex-excess {
      display: flex;
      align-items: center;

      & > .el-checkbox {
        margin: 0 15px;
      }

      & > span {
        display: inline-block;
        padding: 0 15px;
      }
    }

    .form-excess-half {
      width: 500px;
    }
  }

  .car-detail {
    display: flex;
    justify-content: space-between;

    .table {
      width: calc(50% - 10px);
    }
  }

  .box-container {
    width: 800px;
  }

  .refer-text {
    padding-top: 5px;
    font-size: 16px;
    color: #91939A;
  }

}
.extra-content-cancel{
  display: flex;
  flex-direction: column;
  .tr-extra{
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #e1e4e8;
    .extra-title{
      color: #24292e;
      font-weight: 500;
    }
    &:last-child {
      border-bottom: 0;
    }
    .tr {
      //flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
      font-size: 14px;
      color: #24292e;
      line-height: 17px;
      border-bottom: 1px solid #e1e4e8;
      & > span {
        flex: 1;
      }
      &:last-child{
        border-bottom: 0;
      }
    }
  }
}
</style>
